const MeaStudentResult = ({ student, previous = false }) => {

  let sResult = previous ? student?.previous_result : student?.result;


  return (
    <>
      {sResult === "ONGOING" && (
        <div className="text-blue-500 text-sm"><span className="pi pi-play" /><span className="ml-2">EN COURS</span></div>
      )}
      {sResult === "PASSED" && (
        <div className="text-green-500 text-sm"><span className="pi pi-check-circle" /><span className="ml-2">PASSAGE</span></div>
      )}
      {sResult === "FAILED" && (
        <div className="text-red-500 text-sm"><span className="pi pi-exclamation-triangle" /><span className="ml-2">REDOUBLEMENT</span></div>
      )}
      {sResult !== "FAILED" && sResult !== "PASSED" && sResult !== "ONGOING" && (
        <div>-</div>
      )}
    </>
  );

};
export default MeaStudentResult;
